import { TablePermission } from 'store/api/enums';
import {
  EntityStatus,
  SubmissionUpdateField,
  UploadTransactionsSelection,
} from 'store/app/enums';
import { User } from 'store/auth/models';
import { CoaAccountRow } from 'store/chart-of-accounts/models';
import { TaxRate } from 'store/returns/models/returnData';
import { createAction } from 'store/utils';
import { ActivityLog } from 'store/vat/models';
import {
  ADD_EXCEL_ACTIVITY_NOTE_FAILURE,
  ADD_EXCEL_ACTIVITY_NOTE_REQUEST,
  ADD_EXCEL_ACTIVITY_NOTE_SUCCESS,
  ADD_ORGANISATION_FAILURE,
  ADD_ORGANISATION_REQUEST,
  ADD_ORGANISATION_SUCCESS,
  BULK_UPDATE_EXCEL_TRANSACTIONS_FAILURE,
  BULK_UPDATE_EXCEL_TRANSACTIONS_REQUEST,
  BULK_UPDATE_EXCEL_TRANSACTIONS_SUCCESS,
  CLEAR_PENDING_NAVIGATE_AFTER_CREATE,
  CLEAR_UPLOAD_EXCEL_RESULT,
  CLEAR_UPLOAD_TRANSACTIONS_TEMP,
  CONNECT_CIN7_ENTITY_FAILURE,
  CONNECT_CIN7_ENTITY_REQUEST,
  CONNECT_CIN7_ENTITY_SUCCESS,
  CREATE_ENTITY_GROUP_FAILURE,
  CREATE_ENTITY_GROUP_REQUEST,
  CREATE_ENTITY_GROUP_SUCCESS,
  DELETE_ENTITY_GROUP_FAILURE,
  DELETE_ENTITY_GROUP_REQUEST,
  DELETE_ENTITY_GROUP_SUCCESS,
  UPDATE_ENTITY_GROUP_FAILURE,
  UPDATE_ENTITY_GROUP_REQUEST,
  UPDATE_ENTITY_GROUP_SUCCESS,
  DELETE_EXCEL_TRANSACTION_FAILURE,
  DELETE_EXCEL_TRANSACTION_REQUEST,
  DELETE_EXCEL_TRANSACTION_SUCCESS,
  DELETE_EXCEL_TRANSACTIONS_FILE_FAILURE,
  DELETE_EXCEL_TRANSACTIONS_FILE_REQUEST,
  DELETE_EXCEL_TRANSACTIONS_FILE_SUCCESS,
  DELETE_ORGANISATION_ATTACHMENT_FAILURE,
  DELETE_ORGANISATION_ATTACHMENT_REQUEST,
  DELETE_ORGANISATION_ATTACHMENT_SUCCESS,
  DISCONNECT_ORGANISATION_FAILURE,
  DISCONNECT_ORGANISATION_REQUEST,
  DISCONNECT_ORGANISATION_SUCCESS,
  DOWNLOAD_ORGANISATION_ATTACHMENT_FAILURE,
  DOWNLOAD_ORGANISATION_ATTACHMENT_REQUEST,
  DOWNLOAD_ORGANISATION_ATTACHMENT_SUCCESS,
  EDIT_ORGANISATION_FAILURE,
  EDIT_ORGANISATION_REQUEST,
  EDIT_ORGANISATION_SUCCESS,
  FETCH_ACCOUNTS_FAILURE,
  FETCH_ACCOUNTS_REQUEST,
  FETCH_ACCOUNTS_SUCCESS,
  FETCH_ORGANISATION_CONTACTS_FAILURE,
  FETCH_ORGANISATION_CONTACTS_REQUEST,
  FETCH_ORGANISATION_CONTACTS_SUCCESS,
  CREATE_EXCEL_CONTACT_FAILURE,
  CREATE_EXCEL_CONTACT_REQUEST,
  CREATE_EXCEL_CONTACT_SUCCESS,
  UPDATE_EXCEL_CONTACT_FAILURE,
  UPDATE_EXCEL_CONTACT_REQUEST,
  UPDATE_EXCEL_CONTACT_SUCCESS,
  DELETE_EXCEL_CONTACT_FAILURE,
  DELETE_EXCEL_CONTACT_REQUEST,
  DELETE_EXCEL_CONTACT_SUCCESS,
  FETCH_ADD_URL_FAILURE,
  FETCH_ADD_URL_REQUEST,
  FETCH_ADD_URL_SUCCESS,
  FETCH_ALL_EXCEL_TRANSACTIONS_FAILURE,
  FETCH_ALL_EXCEL_TRANSACTIONS_REQUEST,
  FETCH_ALL_EXCEL_TRANSACTIONS_SUCCESS,
  FETCH_EXCEL_ACTIVITY_LOGS_FAILURE,
  FETCH_EXCEL_ACTIVITY_LOGS_REQUEST,
  FETCH_EXCEL_ACTIVITY_LOGS_SUCCESS,
  FETCH_TRACKING_CATEGORIES_FAILURE,
  FETCH_TRACKING_CATEGORIES_REQUEST,
  FETCH_TRACKING_CATEGORIES_SUCCESS,
  FETCH_TRANSACTION_ITEMS_FAILURE,
  FETCH_TRANSACTION_ITEMS_REQUEST,
  FETCH_TRANSACTION_ITEMS_SUCCESS,
  FETCH_EXCEL_FILES_METADATA_FAILURE,
  FETCH_EXCEL_FILES_METADATA_REQUEST,
  FETCH_EXCEL_FILES_METADATA_SUCCESS,
  CLEAR_RECEIPT_UPLOAD_STATUS,
  FETCH_LAST_RECEIPT_UPLOAD_STATUS_FAILURE,
  FETCH_LAST_RECEIPT_UPLOAD_STATUS_REQUEST,
  FETCH_LAST_RECEIPT_UPLOAD_STATUS_SUCCESS,
  FETCH_ORGANISATIONS_FAILURE,
  FETCH_ORGANISATIONS_LIGHT_REQUEST,
  FETCH_ORGANISATIONS_REQUEST,
  FETCH_ORGANISATIONS_SUCCESS,
  FETCH_UPLOADED_FILE_TRANSACTIONS_FAILURE,
  FETCH_UPLOADED_FILE_TRANSACTIONS_REQUEST,
  FETCH_UPLOADED_FILE_TRANSACTIONS_SUCCESS,
  SAVE_EXCEL_DRAWER_TRANSACTIONS_BATCH_FAILURE,
  SAVE_EXCEL_DRAWER_TRANSACTIONS_BATCH_REQUEST,
  SAVE_EXCEL_DRAWER_TRANSACTIONS_BATCH_SUCCESS,
  CLEAR_DRAWER_TRANSACTION_ID_MAP,
  GET_DRIVE_SCANNER_STATUS,
  GET_FILES_UPLOAD_HISTORY,
  REACTIVATE_ORGANISATION_FAILURE,
  REACTIVATE_ORGANISATION_REQUEST,
  REACTIVATE_ORGANISATION_SUCCESS,
  REGISTER_DRIVE_FOLDER,
  RESET_ORGANISATION_DATA,
  SAVE_GOOGLE_TOKEN,
  SET_DRIVE_SCANNER_STATUS,
  SET_FILES_UPLOAD_HISTORY,
  SET_GOOGLE_ACCESS_TOKEN,
  SET_TRANSACTIONS_REVIEWED_FAILURE,
  SET_TRANSACTIONS_REVIEWED_REQUEST,
  SET_TRANSACTIONS_REVIEWED_SUCCESS,
  SET_UPLOAD_TRANSACTIONS_TEMP,
  UPDATE_ENTITY_MEMBERS,
  UPDATE_ENTITY_MEMBERS_BULK,
  UPDATE_EXCEL_TRANSACTION_FAILURE,
  UPDATE_EXCEL_TRANSACTION_REQUEST,
  UPDATE_EXCEL_TRANSACTION_SUCCESS,
  ADD_EXCEL_TRANSACTIONS_FAILURE,
  ADD_EXCEL_TRANSACTIONS_REQUEST,
  ADD_EXCEL_TRANSACTIONS_SUCCESS,
  UPDATE_ORGANISATION_CHART_OF_ACCOUNTS,
  UPDATE_ORGANISATION_DATA,
  UPDATE_ORGANISATION_TAX_RATES,
  UPDATE_ORGANISATION_TOTAL_TAX_BALANCE,
  UPDATE_RECEIPT_FILE_STATUS,
  UPDATE_SUBMISSION_LOG,
  UPLOAD_EXCEL_TRANSACTIONS_FAILURE,
  UPLOAD_EXCEL_TRANSACTIONS_REQUEST,
  UPLOAD_EXCEL_TRANSACTIONS_SUCCESS,
  UPLOAD_ORGANISATION_ATTACHMENT_FAILURE,
  UPLOAD_ORGANISATION_ATTACHMENT_REQUEST,
  UPLOAD_ORGANISATION_ATTACHMENT_SUCCESS,
  UPLOAD_RECEIPT_FAILURE,
  UPLOAD_RECEIPT_REQUEST,
  UPLOAD_RECEIPT_SUCCESS,
  UPLOAD_RECEIPT_TO_PROVIDER_REQUEST,
  UPLOAD_RECEIPT_TO_PROVIDER_SUCCESS,
  UPLOAD_RECEIPT_TO_PROVIDER_FAILURE,
  DISCONNECT_FOLDER,
  RESCAN_FILE,
  GENERATE_SCAN_EMAIL,
  SET_SCAN_EMAIL,
  GET_SCAN_EMAIL_STATUS,
  COMPLETE_SCAN_STEPS_REQUEST,
  COMPLETE_SCAN_STEPS_SUCCESS,
  COMPLETE_SCAN_STEPS_FAILURE,
  HMRC_FRAUD_HEADER_TEST_REQUEST,
  HMRC_FRAUD_HEADER_TEST_SUCCESS,
  HMRC_FRAUD_HEADER_TEST_FAILURE,
  FETCH_RECEIPT_STATISTICS_ALL_REQUEST,
  FETCH_RECEIPT_STATISTICS_ALL_SUCCESS,
  FETCH_RECEIPT_STATISTICS_ALL_FAILURE,
  FETCH_RECEIPT_STATISTICS_ENTITY_REQUEST,
  FETCH_RECEIPT_STATISTICS_ENTITY_SUCCESS,
  FETCH_RECEIPT_STATISTICS_ENTITY_FAILURE,
  INVALIDATE_RECEIPT_STATISTICS,
} from './constants';
import {
  EditOrganisationParams,
  EntityAccount,
  EntityGroupData,
  ExcelFileMetadata,
  ExcelTransaction,
  Mapping,
  NewOrganisationParams,
  Organisation,
  ReceiptStatisticsDateRange,
  ReceiptStatisticsPayload,
  ReceiptStatisticsTotals,
  UploadExcelTransactionsValidationData,
  UploadOrganisationAttachmentParams,
  TrackingCategory,
  TransactionItem,
  ValidatedExcelTransaction,
} from './models';
import { Contact } from 'store/vat-checker/models';
import {
  AddExcelActivityNoteFailureAction,
  AddExcelActivityNoteRequestAction,
  AddExcelActivityNoteSuccessAction,
  AddOrganisationFailureAction,
  AddOrganisationRequestAction,
  AddOrganisationSuccessAction,
  CreateEntityGroupFailureAction,
  CreateEntityGroupRequestAction,
  CreateEntityGroupSuccessAction,
  DeleteEntityGroupFailureAction,
  DeleteEntityGroupRequestAction,
  DeleteEntityGroupSuccessAction,
  UpdateEntityGroupFailureAction,
  UpdateEntityGroupRequestAction,
  UpdateEntityGroupSuccessAction,
  BulkUpdateExcelTransactionsFailureAction,
  BulkUpdateExcelTransactionsRequestAction,
  BulkUpdateExcelTransactionsSuccessAction,
  ClearPendingNavigateAfterCreateAction,
  ClearUploadExcelResultAction,
  ClearUploadTransactionsTempAction,
  ConnectCin7EntityFailureAction,
  ConnectCin7EntityRequestAction,
  ConnectCin7EntitySuccessAction,
  DeleteExcelTransactionsFileFailureAction,
  DeleteExcelTransactionsFileRequestAction,
  DeleteExcelTransactionsFileSuccessAction,
  DeleteOrganisationAttachmentFailureAction,
  DeleteOrganisationAttachmentRequestAction,
  DeleteOrganisationAttachmentSuccessAction,
  DisconnectOrganisationFailureAction,
  DisconnectOrganisationRequestAction,
  DisconnectOrganisationSuccessAction,
  DownloadOrganisationAttachmentFailureAction,
  DownloadOrganisationAttachmentRequestAction,
  DownloadOrganisationAttachmentSuccessAction,
  EditOrganisationFailureAction,
  EditOrganisationRequestAction,
  EditOrganisationSuccessAction,
  FetchAccountsFailureAction,
  FetchAccountsRequestAction,
  FetchAccountsSuccessAction,
  FetchOrganisationContactsFailureAction,
  FetchOrganisationContactsRequestAction,
  FetchOrganisationContactsSuccessAction,
  CreateExcelContactFailureAction,
  CreateExcelContactRequestAction,
  CreateExcelContactSuccessAction,
  UpdateExcelContactFailureAction,
  UpdateExcelContactRequestAction,
  UpdateExcelContactSuccessAction,
  DeleteExcelContactFailureAction,
  DeleteExcelContactRequestAction,
  DeleteExcelContactSuccessAction,
  FetchAddUrlFailureAction,
  FetchAddUrlRequestAction,
  FetchAddUrlSuccessAction,
  FetchAllExcelTransactionsFailureAction,
  FetchAllExcelTransactionsRequestAction,
  FetchAllExcelTransactionsSuccessAction,
  FetchExcelActivityLogsFailureAction,
  FetchExcelActivityLogsRequestAction,
  FetchExcelActivityLogsSuccessAction,
  FetchTrackingCategoriesFailureAction,
  FetchTrackingCategoriesRequestAction,
  FetchTrackingCategoriesSuccessAction,
  FetchTransactionItemsFailureAction,
  FetchTransactionItemsRequestAction,
  FetchTransactionItemsSuccessAction,
  FetchExcelFilesMetadataFailureAction,
  FetchExcelFilesMetadataRequestAction,
  FetchExcelFilesMetadataSuccessAction,
  ClearReceiptUploadStatusAction,
  FetchLastReceiptUploadStatusFailureAction,
  FetchLastReceiptUploadStatusRequestAction,
  FetchLastReceiptUploadStatusSuccessAction,
  FetchReceiptStatisticsAllFailureAction,
  FetchReceiptStatisticsAllRequestAction,
  FetchReceiptStatisticsAllSuccessAction,
  FetchReceiptStatisticsEntityFailureAction,
  FetchReceiptStatisticsEntityRequestAction,
  FetchReceiptStatisticsEntitySuccessAction,
  InvalidateReceiptStatisticsAction,
  FetchOrganisationsFailureAction,
  FetchOrganisationsLightRequestAction,
  FetchOrganisationsRequestAction,
  FetchOrganisationsSuccessAction,
  FetchUploadedFileTransactionsFailureAction,
  FetchUploadedFileTransactionsRequestAction,
  FetchUploadedFileTransactionsSuccessAction,
  GetFilesUploadHistoryAction,
  ReactivateOrganisationFailureAction,
  ReactivateOrganisationRequestAction,
  ReactivateOrganisationSuccessAction,
  RegisterGoogleDriveFolderAction,
  ResetOrganisationDataAction,
  SaveGoogleTokenAction,
  SetFilesUploadHistoryAction,
  SetGoogleAccessTokenAction,
  SaveExcelDrawerTransactionsBatchFailureAction,
  SaveExcelDrawerTransactionsBatchRequestAction,
  SaveExcelDrawerTransactionsBatchRequestActionPayload,
  SaveExcelDrawerTransactionsBatchSuccessAction,
  SaveExcelDrawerTransactionsBatchSuccessActionPayload,
  ClearDrawerTransactionIdMapAction,
  SetTransactionsReviewedFailureAction,
  SetTransactionsReviewedRequestAction,
  SetTransactionsReviewedSuccessAction,
  SetUploadTransactionsTempAction,
  UpdateExcelTransactionFailureAction,
  UpdateExcelTransactionRequestAction,
  UpdateExcelTransactionSuccessAction,
  AddExcelTransactionsFailureAction,
  AddExcelTransactionsRequestAction,
  AddExcelTransactionsSuccessAction,
  UpdateOrganisationChartOfAccountsAction,
  UpdateOrganisationDataAction,
  UpdateOrganisationTaxRatesAction,
  UpdateOrganisationTotalTaxBalanceAction,
  UpdateReceiptFileStatusAction,
  UploadExcelTransactionsFailureAction,
  UploadExcelTransactionsRequestAction,
  UploadExcelTransactionsSuccessAction,
  UploadOrganisationAttachmentFailureAction,
  UploadOrganisationAttachmentRequestAction,
  UploadOrganisationAttachmentSuccessAction,
  UploadReceiptFailureAction,
  UploadReceiptRequestAction,
  UploadReceiptSuccessAction,
  DisconnectFolderAction,
  RescanFileAction,
  SetScanEmailAction,
  CompleteScanStepsRequestAction,
  CompleteScanStepsSuccessAction,
  CompleteScanStepsFailureAction,
  HmrcFraudHeaderTestFailureAction,
  HmrcFraudHeaderTestRequestAction,
  HmrcFraudHeaderTestSuccessAction,
  ProviderPostStatus,
} from './types';

// Fetch Organisations
export const fetchOrganisationsRequest = (
  searchPrompt?: string
): FetchOrganisationsRequestAction =>
  createAction(FETCH_ORGANISATIONS_REQUEST, { searchPrompt });

// Lightweight organisations refresh (no tax rates / excel metadata / pictures fan-out)
export const fetchOrganisationsLightRequest = (
  searchPrompt?: string
): FetchOrganisationsLightRequestAction =>
  createAction(FETCH_ORGANISATIONS_LIGHT_REQUEST, { searchPrompt });

export const fetchOrganisationsSuccess = (
  organisations: Organisation[],
  mappings: Mapping[]
): FetchOrganisationsSuccessAction =>
  createAction(FETCH_ORGANISATIONS_SUCCESS, { organisations, mappings });

export const fetchOrganisationsFailure = (): FetchOrganisationsFailureAction =>
  createAction(FETCH_ORGANISATIONS_FAILURE);

// DIsconnect Organisations
export const disconnectOrganisationsRequest = (
  organisationId: string,
  fromVIES = false,
  statusType?: EntityStatus
): DisconnectOrganisationRequestAction =>
  createAction(DISCONNECT_ORGANISATION_REQUEST, {
    organisationId,
    fromVIES,
    statusType,
  });

export const disconnectOrganisationsSuccess =
  (): DisconnectOrganisationSuccessAction =>
    createAction(DISCONNECT_ORGANISATION_SUCCESS);

export const disconnectOrganisationsFailure =
  (): DisconnectOrganisationFailureAction =>
    createAction(DISCONNECT_ORGANISATION_FAILURE);

// Reactivate Organisation
export const reactivateOrganisationRequest = (
  organisationId: string
): ReactivateOrganisationRequestAction =>
  createAction(REACTIVATE_ORGANISATION_REQUEST, { organisationId });

export const reactivateOrganisationSuccess =
  (): ReactivateOrganisationSuccessAction =>
    createAction(REACTIVATE_ORGANISATION_SUCCESS);

export const reactivateOrganisationFailure =
  (): ReactivateOrganisationFailureAction =>
    createAction(REACTIVATE_ORGANISATION_FAILURE);

// Edit Organisations
export const editOrganisationsRequest = (
  editOrganisation: EditOrganisationParams,
  fromVATChecker = false
): EditOrganisationRequestAction =>
  createAction(EDIT_ORGANISATION_REQUEST, { editOrganisation, fromVATChecker });

export const editOrganisationsSuccess = (): EditOrganisationSuccessAction =>
  createAction(EDIT_ORGANISATION_SUCCESS);

export const editOrganisationsFailure = (): EditOrganisationFailureAction =>
  createAction(EDIT_ORGANISATION_FAILURE);

// Fetch Add Url
export const fetchAddUrlRequest = (
  providerName: string,
  uuid: string,
  sourceUrl: string,
  providerFormattedName: string
): FetchAddUrlRequestAction =>
  createAction(FETCH_ADD_URL_REQUEST, {
    providerName,
    uuid,
    sourceUrl,
    providerFormattedName,
  });

export const fetchAddUrlSuccess = (): FetchAddUrlSuccessAction =>
  createAction(FETCH_ADD_URL_SUCCESS);

export const fetchAddUrlFailure = (): FetchAddUrlFailureAction =>
  createAction(FETCH_ADD_URL_FAILURE);

// Fetch Accounts
export const fetchAccountsRequest = (
  connectionId: string,
  mappingId: string
): FetchAccountsRequestAction =>
  createAction(FETCH_ACCOUNTS_REQUEST, { connectionId, mappingId });

export const fetchAccountsSuccess = (
  connectionId: string,
  entityAccounts: EntityAccount[]
): FetchAccountsSuccessAction =>
  createAction(FETCH_ACCOUNTS_SUCCESS, { connectionId, entityAccounts });

export const fetchAccountsFailure = (): FetchAccountsFailureAction =>
  createAction(FETCH_ACCOUNTS_FAILURE);

// Fetch organisation VIES contacts
export const fetchOrganisationContactsRequest = (
  connectionId: string
): FetchOrganisationContactsRequestAction =>
  createAction(FETCH_ORGANISATION_CONTACTS_REQUEST, { connectionId });

export const fetchOrganisationContactsSuccess = (
  connectionId: string,
  contacts: Contact[]
): FetchOrganisationContactsSuccessAction =>
  createAction(FETCH_ORGANISATION_CONTACTS_SUCCESS, {
    connectionId,
    contacts,
  });

export const fetchOrganisationContactsFailure =
  (): FetchOrganisationContactsFailureAction =>
    createAction(FETCH_ORGANISATION_CONTACTS_FAILURE);

export const createExcelContactRequest = (
  organisationId: string,
  excelContact: Contact
): CreateExcelContactRequestAction =>
  createAction(CREATE_EXCEL_CONTACT_REQUEST, { organisationId, excelContact });

export const createExcelContactSuccess = (): CreateExcelContactSuccessAction =>
  createAction(CREATE_EXCEL_CONTACT_SUCCESS);

export const createExcelContactFailure = (): CreateExcelContactFailureAction =>
  createAction(CREATE_EXCEL_CONTACT_FAILURE);

export const updateExcelContactRequest = (
  organisationId: string,
  contactUuid: string,
  excelContact: Contact
): UpdateExcelContactRequestAction =>
  createAction(UPDATE_EXCEL_CONTACT_REQUEST, {
    organisationId,
    contactUuid,
    excelContact,
  });

export const updateExcelContactSuccess = (): UpdateExcelContactSuccessAction =>
  createAction(UPDATE_EXCEL_CONTACT_SUCCESS);

export const updateExcelContactFailure = (): UpdateExcelContactFailureAction =>
  createAction(UPDATE_EXCEL_CONTACT_FAILURE);

export const deleteExcelContactRequest = (
  organisationId: string,
  contactUuid: string
): DeleteExcelContactRequestAction =>
  createAction(DELETE_EXCEL_CONTACT_REQUEST, { organisationId, contactUuid });

export const deleteExcelContactSuccess = (): DeleteExcelContactSuccessAction =>
  createAction(DELETE_EXCEL_CONTACT_SUCCESS);

export const deleteExcelContactFailure = (): DeleteExcelContactFailureAction =>
  createAction(DELETE_EXCEL_CONTACT_FAILURE);

// Update members
export const updateEntityMembers = (
  organisationId: string,
  member: User,
  tablePermission: TablePermission
) =>
  createAction(UPDATE_ENTITY_MEMBERS, {
    organisationId,
    member,
    tablePermission,
  });

export const updateEntityMembersBulk = (
  items: {
    organisationId: string;
    member: User;
    tablePermission: TablePermission;
  }[]
) => createAction(UPDATE_ENTITY_MEMBERS_BULK, { items });

// Fetch Add Url
export const connectCin7EntityRequest = (
  key: string,
  cin7accountId: string,
  orgName: string
): ConnectCin7EntityRequestAction =>
  createAction(CONNECT_CIN7_ENTITY_REQUEST, { key, cin7accountId, orgName });

export const connectCin7EntitySuccess = (): ConnectCin7EntitySuccessAction =>
  createAction(CONNECT_CIN7_ENTITY_SUCCESS);

export const connectCin7EntityFailure = (): ConnectCin7EntityFailureAction =>
  createAction(CONNECT_CIN7_ENTITY_FAILURE);

// Update submission log
export const updateSubmissionLog = (
  mappingId: string,
  submissionUpdateField: SubmissionUpdateField,
  data: any,
  dataLogId?: string
) =>
  createAction(UPDATE_SUBMISSION_LOG, {
    mappingId,
    submissionUpdateField,
    data,
    dataLogId,
  });

// RESET
export const resetOrganisationData = (): ResetOrganisationDataAction =>
  createAction(RESET_ORGANISATION_DATA);

// RESET
export const updateOrganisationData = (
  entityId: string,
  vatCheckerActive: boolean
): UpdateOrganisationDataAction =>
  createAction(UPDATE_ORGANISATION_DATA, { entityId, vatCheckerActive });

export const updateOrganisationChartOfAccounts = (
  organisationId: string,
  chartOfAccounts: CoaAccountRow[],
  chartOfAccountsLoaded = true
): UpdateOrganisationChartOfAccountsAction =>
  createAction(UPDATE_ORGANISATION_CHART_OF_ACCOUNTS, {
    organisationId,
    chartOfAccounts,
    chartOfAccountsLoaded,
  });

export const updateOrganisationTaxRates = (
  connectionId: string,
  taxRates: TaxRate[],
  taxEnabled: boolean,
  taxRatesUnique?: TaxRate[]
): UpdateOrganisationTaxRatesAction =>
  createAction(UPDATE_ORGANISATION_TAX_RATES, {
    connectionId,
    taxRates,
    taxEnabled,
    taxRatesUnique,
  });

export const updateOrganisationTotalTaxBalance = (
  organisationId: string,
  totalTaxBalance: number
): UpdateOrganisationTotalTaxBalanceAction =>
  createAction(UPDATE_ORGANISATION_TOTAL_TAX_BALANCE, {
    organisationId,
    totalTaxBalance,
  });

// Upload Organisation Attachment
export const uploadOrganisationAttachmentRequest = (
  params: UploadOrganisationAttachmentParams
): UploadOrganisationAttachmentRequestAction =>
  createAction(UPLOAD_ORGANISATION_ATTACHMENT_REQUEST, { params });

export const uploadOrganisationAttachmentSuccess = (
  organisationId: string,
  attachment: any
): UploadOrganisationAttachmentSuccessAction =>
  createAction(UPLOAD_ORGANISATION_ATTACHMENT_SUCCESS, {
    organisationId,
    attachment,
  });

export const uploadOrganisationAttachmentFailure =
  (): UploadOrganisationAttachmentFailureAction =>
    createAction(UPLOAD_ORGANISATION_ATTACHMENT_FAILURE);

// Delete Organisation Attachment
export const deleteOrganisationAttachmentRequest = (
  organisationId: string,
  attachmentId: string
): DeleteOrganisationAttachmentRequestAction =>
  createAction(DELETE_ORGANISATION_ATTACHMENT_REQUEST, {
    organisationId,
    attachmentId,
  });

export const deleteOrganisationAttachmentSuccess =
  (): DeleteOrganisationAttachmentSuccessAction =>
    createAction(DELETE_ORGANISATION_ATTACHMENT_SUCCESS);

export const deleteOrganisationAttachmentFailure =
  (): DeleteOrganisationAttachmentFailureAction =>
    createAction(DELETE_ORGANISATION_ATTACHMENT_FAILURE);

// Download Organisation Attachment
export const downloadOrganisationAttachmentRequest = (
  organisationId: string,
  attachmentId: string
): DownloadOrganisationAttachmentRequestAction =>
  createAction(DOWNLOAD_ORGANISATION_ATTACHMENT_REQUEST, {
    organisationId,
    attachmentId,
  });

export const downloadOrganisationAttachmentSuccess =
  (): DownloadOrganisationAttachmentSuccessAction =>
    createAction(DOWNLOAD_ORGANISATION_ATTACHMENT_SUCCESS);

export const downloadOrganisationAttachmentFailure =
  (): DownloadOrganisationAttachmentFailureAction =>
    createAction(DOWNLOAD_ORGANISATION_ATTACHMENT_FAILURE);

// Add Organisation
export const addOrganisationRequest = (
  addOrganisation: NewOrganisationParams
): AddOrganisationRequestAction =>
  createAction(ADD_ORGANISATION_REQUEST, { addOrganisation });

export const addOrganisationSuccess = (): AddOrganisationSuccessAction =>
  createAction(ADD_ORGANISATION_SUCCESS);

export const addOrganisationFailure = (): AddOrganisationFailureAction =>
  createAction(ADD_ORGANISATION_FAILURE);

export const createEntityGroupRequest = (
  groupData: EntityGroupData
): CreateEntityGroupRequestAction =>
  createAction(CREATE_ENTITY_GROUP_REQUEST, { groupData });

export const createEntityGroupSuccess = (): CreateEntityGroupSuccessAction =>
  createAction(CREATE_ENTITY_GROUP_SUCCESS);

export const createEntityGroupFailure = (): CreateEntityGroupFailureAction =>
  createAction(CREATE_ENTITY_GROUP_FAILURE);

export const updateEntityGroupRequest = (
  groupId: string,
  groupData: EntityGroupData
): UpdateEntityGroupRequestAction =>
  createAction(UPDATE_ENTITY_GROUP_REQUEST, { groupId, groupData });

export const updateEntityGroupSuccess = (): UpdateEntityGroupSuccessAction =>
  createAction(UPDATE_ENTITY_GROUP_SUCCESS);

export const updateEntityGroupFailure = (): UpdateEntityGroupFailureAction =>
  createAction(UPDATE_ENTITY_GROUP_FAILURE);

export const deleteEntityGroupRequest = (
  groupId: string
): DeleteEntityGroupRequestAction =>
  createAction(DELETE_ENTITY_GROUP_REQUEST, { groupId });

export const deleteEntityGroupSuccess = (): DeleteEntityGroupSuccessAction =>
  createAction(DELETE_ENTITY_GROUP_SUCCESS);

export const deleteEntityGroupFailure = (): DeleteEntityGroupFailureAction =>
  createAction(DELETE_ENTITY_GROUP_FAILURE);

export const clearPendingNavigateAfterCreate =
  (): ClearPendingNavigateAfterCreateAction =>
    createAction(CLEAR_PENDING_NAVIGATE_AFTER_CREATE);

// Temporarily store uploaded transactions file and selected option
export const setUploadTransactionsTemp = (
  file: File,
  selection: UploadTransactionsSelection
): SetUploadTransactionsTempAction =>
  createAction(SET_UPLOAD_TRANSACTIONS_TEMP, { file, selection });

export const clearUploadTransactionsTemp =
  (): ClearUploadTransactionsTempAction =>
    createAction(CLEAR_UPLOAD_TRANSACTIONS_TEMP);

// Upload Excel Transactions (file comes from getUploadTransactionsTemp in saga)
export const uploadExcelTransactionsRequest = (
  organisationId: string,
  forceDuplicates: boolean,
  mapping: string
): UploadExcelTransactionsRequestAction =>
  createAction(UPLOAD_EXCEL_TRANSACTIONS_REQUEST, {
    organisationId,
    forceDuplicates,
    mapping,
  });

export const uploadExcelTransactionsSuccess = (
  importId: string,
  organisationId: string
): UploadExcelTransactionsSuccessAction =>
  createAction(UPLOAD_EXCEL_TRANSACTIONS_SUCCESS, { importId, organisationId });

export const uploadExcelTransactionsFailure = (
  validationData: UploadExcelTransactionsValidationData
): UploadExcelTransactionsFailureAction =>
  createAction(UPLOAD_EXCEL_TRANSACTIONS_FAILURE, { validationData });

export const clearUploadExcelResult = (): ClearUploadExcelResultAction =>
  createAction(CLEAR_UPLOAD_EXCEL_RESULT);

// Fetch Excel Files Metadata (updates organisation.excelFilesMetadata in place)
export const fetchExcelFilesMetadataRequest = (
  organisationId: string
): FetchExcelFilesMetadataRequestAction =>
  createAction(FETCH_EXCEL_FILES_METADATA_REQUEST, { organisationId });

export const fetchExcelFilesMetadataSuccess = (
  organisationId: string,
  files: ExcelFileMetadata[]
): FetchExcelFilesMetadataSuccessAction =>
  createAction(FETCH_EXCEL_FILES_METADATA_SUCCESS, { organisationId, files });

export const fetchExcelFilesMetadataFailure =
  (): FetchExcelFilesMetadataFailureAction =>
    createAction(FETCH_EXCEL_FILES_METADATA_FAILURE);

// Delete Excel Transactions File
export const deleteExcelTransactionsFileRequest = (
  organisationId: string,
  importId: string,
  refreshParams?: {
    page: number;
    pageSize: number;
    filters?: Record<string, unknown>;
  }
): DeleteExcelTransactionsFileRequestAction =>
  createAction(DELETE_EXCEL_TRANSACTIONS_FILE_REQUEST, {
    organisationId,
    importId,
    refreshParams,
  });

export const deleteExcelTransactionsFileSuccess =
  (): DeleteExcelTransactionsFileSuccessAction =>
    createAction(DELETE_EXCEL_TRANSACTIONS_FILE_SUCCESS);

export const deleteExcelTransactionsFileFailure =
  (): DeleteExcelTransactionsFileFailureAction =>
    createAction(DELETE_EXCEL_TRANSACTIONS_FILE_FAILURE);

// Fetch Uploaded File Transactions (paginated; used when upload status is success)
export const fetchUploadedFileTransactionsRequest = (
  organisationId: string,
  importId: string,
  page: number,
  pageSize: number
): FetchUploadedFileTransactionsRequestAction =>
  createAction(FETCH_UPLOADED_FILE_TRANSACTIONS_REQUEST, {
    organisationId,
    importId,
    page,
    pageSize,
  });

export const fetchUploadedFileTransactionsSuccess = (
  transactions: ValidatedExcelTransaction[],
  total: number,
  page: number,
  pageSize: number
): FetchUploadedFileTransactionsSuccessAction =>
  createAction(FETCH_UPLOADED_FILE_TRANSACTIONS_SUCCESS, {
    transactions,
    total,
    page,
    pageSize,
  });

export const fetchUploadedFileTransactionsFailure =
  (): FetchUploadedFileTransactionsFailureAction =>
    createAction(FETCH_UPLOADED_FILE_TRANSACTIONS_FAILURE);

// Fetch All Excel Transactions (paginated; transactions tab)
// Optional filters parameter allows passing sort/filter info from ScopeTable
// (e.g. { sort: ['transactionDate', 'asc'], ... }).
export const fetchAllExcelTransactionsRequest = (
  organisationId: string,
  page: number = 1,
  pageSize: number = 10,
  filters?: Record<string, unknown>
): FetchAllExcelTransactionsRequestAction =>
  createAction(FETCH_ALL_EXCEL_TRANSACTIONS_REQUEST, {
    organisationId,
    page,
    pageSize,
    ...(filters ? { filters } : {}),
  });

export const fetchAllExcelTransactionsSuccess = (
  organisationId: string,
  transactions: ValidatedExcelTransaction[],
  total: number,
  page: number,
  pageSize: number
): FetchAllExcelTransactionsSuccessAction =>
  createAction(FETCH_ALL_EXCEL_TRANSACTIONS_SUCCESS, {
    organisationId,
    transactions,
    total,
    page,
    pageSize,
  });

export const fetchAllExcelTransactionsFailure =
  (): FetchAllExcelTransactionsFailureAction =>
    createAction(FETCH_ALL_EXCEL_TRANSACTIONS_FAILURE);

// Delete single Excel transaction (row-level delete in transactions tab)
export const deleteExcelTransactionRequest = (
  organisationId: string,
  transactionUuid: string,
  refreshParams?: {
    page: number;
    pageSize: number;
    filters?: Record<string, unknown>;
  }
) =>
  createAction(DELETE_EXCEL_TRANSACTION_REQUEST, {
    organisationId,
    transactionUuid,
    refreshParams,
  });

export const deleteExcelTransactionSuccess = () =>
  createAction(DELETE_EXCEL_TRANSACTION_SUCCESS);

export const deleteExcelTransactionFailure = () =>
  createAction(DELETE_EXCEL_TRANSACTION_FAILURE);

// Update single Excel transaction
export const updateExcelTransactionRequest = (
  organisationId: string,
  transactionUuid: string,
  body: ExcelTransaction,
  refreshParams?: {
    page: number;
    pageSize: number;
    filters?: Record<string, unknown>;
    tabFileImportIds?: string[];
    /** When set, saga will dispatch setTransactionsReviewedRequest after update succeeds. */
    markAsReviewedIds?: string[];
  }
): UpdateExcelTransactionRequestAction =>
  createAction(UPDATE_EXCEL_TRANSACTION_REQUEST, {
    organisationId,
    transactionUuid,
    body,
    refreshParams,
  });

export const updateExcelTransactionSuccess =
  (): UpdateExcelTransactionSuccessAction =>
    createAction(UPDATE_EXCEL_TRANSACTION_SUCCESS);

export const updateExcelTransactionFailure =
  (): UpdateExcelTransactionFailureAction =>
    createAction(UPDATE_EXCEL_TRANSACTION_FAILURE);

/** Add manual Excel journal rows (`List<ExcelJournalDTO>` — same item shape as edit). */
export const addExcelTransactionsRequest = (
  organisationId: string,
  body: ExcelTransaction[],
  refreshParams?: {
    page: number;
    pageSize: number;
    filters?: Record<string, unknown>;
    tabFileImportIds?: string[];
  }
): AddExcelTransactionsRequestAction =>
  createAction(ADD_EXCEL_TRANSACTIONS_REQUEST, {
    organisationId,
    body,
    refreshParams,
  });

export const addExcelTransactionsSuccess =
  (): AddExcelTransactionsSuccessAction =>
    createAction(ADD_EXCEL_TRANSACTIONS_SUCCESS);

export const addExcelTransactionsFailure =
  (): AddExcelTransactionsFailureAction =>
    createAction(ADD_EXCEL_TRANSACTIONS_FAILURE);

/** Save every line shown in the multi-line transaction drawer. */
export const saveExcelDrawerTransactionsBatchRequest = (
  organisationId: string,
  items: SaveExcelDrawerTransactionsBatchRequestActionPayload['items'],
  refreshParams: SaveExcelDrawerTransactionsBatchRequestActionPayload['refreshParams']
): SaveExcelDrawerTransactionsBatchRequestAction =>
  createAction(SAVE_EXCEL_DRAWER_TRANSACTIONS_BATCH_REQUEST, {
    organisationId,
    items,
    refreshParams,
  });

export const saveExcelDrawerTransactionsBatchSuccess = (
  payload?: SaveExcelDrawerTransactionsBatchSuccessActionPayload
): SaveExcelDrawerTransactionsBatchSuccessAction =>
  createAction(SAVE_EXCEL_DRAWER_TRANSACTIONS_BATCH_SUCCESS, payload);

export const saveExcelDrawerTransactionsBatchFailure =
  (): SaveExcelDrawerTransactionsBatchFailureAction =>
    createAction(SAVE_EXCEL_DRAWER_TRANSACTIONS_BATCH_FAILURE);

/** Clears open-drawer saved-id hops (call on edit drawer open and close). */
export const clearDrawerTransactionIdMap =
  (): ClearDrawerTransactionIdMapAction =>
    createAction(CLEAR_DRAWER_TRANSACTION_ID_MAP);

// Upload Receipt (image file for an organisation)
export const uploadReceiptRequest = (
  organisationId: string,
  files: File[],
  grouped?: boolean
): UploadReceiptRequestAction =>
  createAction(UPLOAD_RECEIPT_REQUEST, {
    organisationId,
    files,
    grouped,
  });

export const uploadReceiptSuccess = (
  batchId: string
): UploadReceiptSuccessAction =>
  createAction(UPLOAD_RECEIPT_SUCCESS, { batchId });

export const uploadReceiptFailure = (): UploadReceiptFailureAction =>
  createAction(UPLOAD_RECEIPT_FAILURE);

// Fetch status of last receipts upload (by organisationId)
export const fetchLastReceiptUploadStatusRequest = (
  organisationId: string
): FetchLastReceiptUploadStatusRequestAction =>
  createAction(FETCH_LAST_RECEIPT_UPLOAD_STATUS_REQUEST, { organisationId });

export const fetchLastReceiptUploadStatusSuccess = (
  status: any
): FetchLastReceiptUploadStatusSuccessAction =>
  createAction(FETCH_LAST_RECEIPT_UPLOAD_STATUS_SUCCESS, { status });

export const fetchLastReceiptUploadStatusFailure =
  (): FetchLastReceiptUploadStatusFailureAction =>
    createAction(FETCH_LAST_RECEIPT_UPLOAD_STATUS_FAILURE);

// Clear cached receipts upload status + batch id (e.g. when the user closes
// the completed "Uploaded files" panel) so the next upload starts clean.
export const clearReceiptUploadStatus = (): ClearReceiptUploadStatusAction =>
  createAction(CLEAR_RECEIPT_UPLOAD_STATUS);

export const fetchReceiptStatisticsAllRequest = (
  dateRange: ReceiptStatisticsDateRange = {}
): FetchReceiptStatisticsAllRequestAction =>
  createAction(FETCH_RECEIPT_STATISTICS_ALL_REQUEST, dateRange);

export const fetchReceiptStatisticsAllSuccess = (
  statistics: ReceiptStatisticsPayload,
  dateRange: ReceiptStatisticsDateRange
): FetchReceiptStatisticsAllSuccessAction =>
  createAction(FETCH_RECEIPT_STATISTICS_ALL_SUCCESS, {
    statistics,
    dateRange,
  });

export const fetchReceiptStatisticsAllFailure =
  (): FetchReceiptStatisticsAllFailureAction =>
    createAction(FETCH_RECEIPT_STATISTICS_ALL_FAILURE);

export const fetchReceiptStatisticsEntityRequest = (
  connectionId: string,
  dateRange: ReceiptStatisticsDateRange = {}
): FetchReceiptStatisticsEntityRequestAction =>
  createAction(FETCH_RECEIPT_STATISTICS_ENTITY_REQUEST, {
    connectionId,
    ...dateRange,
  });

export const fetchReceiptStatisticsEntitySuccess = (
  cacheKey: string,
  statistics: ReceiptStatisticsTotals
): FetchReceiptStatisticsEntitySuccessAction =>
  createAction(FETCH_RECEIPT_STATISTICS_ENTITY_SUCCESS, {
    cacheKey,
    statistics,
  });

export const fetchReceiptStatisticsEntityFailure =
  (): FetchReceiptStatisticsEntityFailureAction =>
    createAction(FETCH_RECEIPT_STATISTICS_ENTITY_FAILURE);

export const invalidateReceiptStatistics =
  (): InvalidateReceiptStatisticsAction =>
    createAction(INVALIDATE_RECEIPT_STATISTICS);

// Set transactions to reviewed
export const setTransactionsReviewedRequest = (
  organisationId: string,
  reviewIds: string[],
  page?: number,
  pageSize?: number,
  filters?: Record<string, unknown>,
  tabFileImportIds?: string[],
  suppressSuccessMessage?: boolean
): SetTransactionsReviewedRequestAction =>
  createAction(SET_TRANSACTIONS_REVIEWED_REQUEST, {
    organisationId,
    reviewIds,
    page,
    pageSize,
    filters,
    tabFileImportIds,
    suppressSuccessMessage,
  });

export const setTransactionsReviewedSuccess =
  (): SetTransactionsReviewedSuccessAction =>
    createAction(SET_TRANSACTIONS_REVIEWED_SUCCESS);

export const setTransactionsReviewedFailure =
  (): SetTransactionsReviewedFailureAction =>
    createAction(SET_TRANSACTIONS_REVIEWED_FAILURE);

// Bulk update Excel transactions (mass edit: same field(s) for multiple rows)
export const bulkUpdateExcelTransactionsRequest = (
  organisationId: string,
  ids: string[],
  updates: Record<string, unknown>,
  refreshParams?: {
    page: number;
    pageSize: number;
    filters?: Record<string, unknown>;
    tabFileImportIds?: string[];
  }
): BulkUpdateExcelTransactionsRequestAction =>
  createAction(BULK_UPDATE_EXCEL_TRANSACTIONS_REQUEST, {
    organisationId,
    ids,
    updates,
    page: refreshParams?.page,
    pageSize: refreshParams?.pageSize,
    filters: refreshParams?.filters,
    tabFileImportIds: refreshParams?.tabFileImportIds,
  });

export const bulkUpdateExcelTransactionsSuccess =
  (): BulkUpdateExcelTransactionsSuccessAction =>
    createAction(BULK_UPDATE_EXCEL_TRANSACTIONS_SUCCESS);

export const bulkUpdateExcelTransactionsFailure =
  (): BulkUpdateExcelTransactionsFailureAction =>
    createAction(BULK_UPDATE_EXCEL_TRANSACTIONS_FAILURE);

// Fetch Excel activity logs for an organisation (transactions timeline)
export const fetchExcelActivityLogsRequest = (
  organisationId: string
): FetchExcelActivityLogsRequestAction =>
  createAction(FETCH_EXCEL_ACTIVITY_LOGS_REQUEST, { organisationId });

export const fetchExcelActivityLogsSuccess = (
  organisationId: string,
  activityLogs: ActivityLog[]
): FetchExcelActivityLogsSuccessAction =>
  createAction(FETCH_EXCEL_ACTIVITY_LOGS_SUCCESS, {
    organisationId,
    activityLogs,
  });

export const fetchExcelActivityLogsFailure =
  (): FetchExcelActivityLogsFailureAction =>
    createAction(FETCH_EXCEL_ACTIVITY_LOGS_FAILURE);

// Fetch tracking categories for an organisation (e.g. Xero dimensions)
export const fetchTrackingCategoriesRequest = (
  organisationId: string
): FetchTrackingCategoriesRequestAction =>
  createAction(FETCH_TRACKING_CATEGORIES_REQUEST, { organisationId });

export const fetchTrackingCategoriesSuccess = (
  organisationId: string,
  trackingCategories: TrackingCategory[]
): FetchTrackingCategoriesSuccessAction =>
  createAction(FETCH_TRACKING_CATEGORIES_SUCCESS, {
    organisationId,
    trackingCategories,
  });

export const fetchTrackingCategoriesFailure =
  (): FetchTrackingCategoriesFailureAction =>
    createAction(FETCH_TRACKING_CATEGORIES_FAILURE);

// Fetch transaction items for an organisation (e.g. Xero items)
export const fetchTransactionItemsRequest = (
  organisationId: string
): FetchTransactionItemsRequestAction =>
  createAction(FETCH_TRANSACTION_ITEMS_REQUEST, { organisationId });

export const fetchTransactionItemsSuccess = (
  organisationId: string,
  transactionItems: TransactionItem[]
): FetchTransactionItemsSuccessAction =>
  createAction(FETCH_TRANSACTION_ITEMS_SUCCESS, {
    organisationId,
    transactionItems,
  });

export const fetchTransactionItemsFailure =
  (): FetchTransactionItemsFailureAction =>
    createAction(FETCH_TRANSACTION_ITEMS_FAILURE);

// Add a custom Excel activity note for an organisation
export const addExcelActivityNoteRequest = (
  organisationId: string,
  note: string
): AddExcelActivityNoteRequestAction =>
  createAction(ADD_EXCEL_ACTIVITY_NOTE_REQUEST, { organisationId, note });

export const addExcelActivityNoteSuccess =
  (): AddExcelActivityNoteSuccessAction =>
    createAction(ADD_EXCEL_ACTIVITY_NOTE_SUCCESS);

export const addExcelActivityNoteFailure =
  (): AddExcelActivityNoteFailureAction =>
    createAction(ADD_EXCEL_ACTIVITY_NOTE_FAILURE);

export const saveGoogleToken = (
  code: string,
  connectionId: string
): SaveGoogleTokenAction => {
  return createAction(SAVE_GOOGLE_TOKEN, { code, connectionId });
};

export const setGoogleAccessToken = (
  code: string | null
): SetGoogleAccessTokenAction => {
  return createAction(SET_GOOGLE_ACCESS_TOKEN, { code });
};

export const registerDriveFolder = (
  folderId: string,
  connectionId: string,
  driveId: string | null,
  type: 'google' | 'one',
  syncExistingFiles: boolean
): RegisterGoogleDriveFolderAction => {
  return createAction(REGISTER_DRIVE_FOLDER, {
    folderId,
    connectionId,
    driveId,
    type,
    syncExistingFiles,
  });
};

export const getDriveScannerStatus = (connectionId: string): any => {
  return createAction(GET_DRIVE_SCANNER_STATUS, { connectionId });
};

export const setDriveScannerStatus = (
  googleStatus: any,
  oneDriveStatus: any
) => {
  return createAction(SET_DRIVE_SCANNER_STATUS, {
    googleStatus,
    oneDriveStatus,
  });
};

export const getFilesUploadHistoryRequest = (
  connectionId: string,
  type: string
): GetFilesUploadHistoryAction => {
  return createAction(GET_FILES_UPLOAD_HISTORY, { connectionId, type });
};

export const setFilesUploadHistory = (
  data: any
): SetFilesUploadHistoryAction => {
  return createAction(SET_FILES_UPLOAD_HISTORY, {
    data,
  });
};

export const uploadReceiptToProvider = (
  connectionId: string,
  filesIds: string[],
  status?: ProviderPostStatus,
  bankAccountId?: string | null
) => {
  return createAction(UPLOAD_RECEIPT_TO_PROVIDER_REQUEST, {
    connectionId,
    filesIds,
    status,
    bankAccountId,
  });
};

export const uploadReceiptToProviderSuccess = (filesIds: string[]) => {
  return createAction(UPLOAD_RECEIPT_TO_PROVIDER_SUCCESS, { filesIds });
};

export const uploadReceiptToProviderFailure = (filesIds: string[]) => {
  return createAction(UPLOAD_RECEIPT_TO_PROVIDER_FAILURE, { filesIds });
};

export const updateReceiptFileStatus = (
  connectionId: string,
  fileId: string,
  link: string
): UpdateReceiptFileStatusAction => {
  return createAction(UPDATE_RECEIPT_FILE_STATUS, {
    connectionId,
    fileId,
    link,
  });
};

export const disconnectFolderRequest = (
  type: 'google' | 'one',
  connectionId: string
): DisconnectFolderAction => {
  return createAction(DISCONNECT_FOLDER, { type, connectionId });
};

export const rescanReceipt = (
  organisationId: string,
  fileId: string,
  grouped?: boolean
): RescanFileAction => {
  return createAction(RESCAN_FILE, { organisationId, fileId, grouped });
};

export const generateScanEmail = (connectionId: string): any => {
  return createAction(GENERATE_SCAN_EMAIL, { connectionId });
};

export const setScanEmail = (response: any): SetScanEmailAction => {
  return createAction(SET_SCAN_EMAIL, { response });
};

export const getScanEmailStatus = (connectionId: string): any => {
  return createAction(GET_SCAN_EMAIL_STATUS, { connectionId });
};

export const completeScanStepsRequest = (
  organisationId: string
): CompleteScanStepsRequestAction => {
  return createAction(COMPLETE_SCAN_STEPS_REQUEST, { organisationId });
};

export const completeScanStepsSuccess = (
  organisationId: string
): CompleteScanStepsSuccessAction => {
  return createAction(COMPLETE_SCAN_STEPS_SUCCESS, { organisationId });
};

export const completeScanStepsFailure = (): CompleteScanStepsFailureAction => {
  return createAction(COMPLETE_SCAN_STEPS_FAILURE);
};

export const hmrcFraudHeaderTestRequest = (
  connectionId: string
): HmrcFraudHeaderTestRequestAction =>
  createAction(HMRC_FRAUD_HEADER_TEST_REQUEST, { connectionId });

export const hmrcFraudHeaderTestSuccess = (
  connectionId: string,
  result: Record<string, unknown>
): HmrcFraudHeaderTestSuccessAction =>
  createAction(HMRC_FRAUD_HEADER_TEST_SUCCESS, { connectionId, result });

export const hmrcFraudHeaderTestFailure =
  (): HmrcFraudHeaderTestFailureAction =>
    createAction(HMRC_FRAUD_HEADER_TEST_FAILURE);
